function importAll(r) {
    return r.keys().map(r);
  }
  
  const Poland_L = importAll(require.context('../assets/photos/Poland_L', false, /\.(png|jpe?g|svg)$/));
    
  export default Poland_L;